import { render, staticRenderFns } from "./WCalendar.vue?vue&type=template&id=286e2af5&scoped=true&"
import script from "./WCalendar.vue?vue&type=script&setup=true&lang=js&"
export * from "./WCalendar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e2af5",
  null
  
)

export default component.exports